<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      max-width="600"
      content-class="rounded-dialog"
    >
      <v-card color="white">
        <v-card-title dark class="dialog-header">
          <div class="dialog-header-content">
            <div class="dialog-title-wrapper">
              <div class="dialog-icon">
                <icon name="global-icon" />
              </div>

              <div class="dialog-text">
                <div class="dialog-title">Pending Remarks</div>

                <div class="dialog-subtitle">
                  Review and provide remarks explaining why it is pending.
                </div>
              </div>
            </div>

            <v-btn icon class="close-btn" @click="close()">
              <icon name="circle-close" />
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="remarks-container">
          <v-timeline dense class="remarks-timeline">
            <v-timeline-item
              v-for="n in list"
              :key="n.id"
              color="#147452"
              small
              fill-dot
              icon="mdi-message-text-outline"
            >
              <div
                class="remark-card"
                :class="{
                  unread: viewFrom == 'Owner' && n.isOpenned == 0,
                }"
              >
                <div class="remark-message">
                  {{ n.message }}
                </div>

                <div class="remark-footer">
                  <div>
                    <div class="remark-user">
                      {{ getUserName(n.remarks_maker_userID) }}
                    </div>

                    <div class="remark-date">
                      {{ formatDate(n.createdAt) }}
                    </div>
                  </div>

                  <div
                    v-if="viewFrom == 'Owner' && n.isOpenned == 0"
                    class="remark-badge"
                  >
                    New
                  </div>
                </div>
              </div>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-dialog>
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import icon from "@/assets/icon.vue";
export default {
  props: {
    data: null,
    viewFrom: null,
  },
  components: { icon },
  data() {
    return {
      dialog: false,
      remarksMsg: null,
      isSubmitLoading: false,
      list: [],
      users: [],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        if (data.length > 0) {
          //   this.remarksMsg = null;
          this.list = data;
          this.getUsers();
          this.dialog = true;
          if (this.viewFrom == "Owner") {
            this.setOpenned();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit("closeRemarksTimeline", null);
    },

    getUsers() {
      this.axiosCall("/user-details/getAllUserDetail", "GET").then((res) => {
        this.users = res.data;
      });
    },

    getUserName(id) {
      let userID = this.$store.getters.getUserData.id;
      if (id == userID) {
        return "You";
      } else {
        if (this.users.length > 0) {
          let idx = this.users.findIndex((u) => u.id == id);
          return this.toTitleCase(this.users[idx].name);
        }
      }

      return;
    },

    setOpenned() {
      let toUpdate = [];
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].isOpenned == 0) {
          toUpdate.push(this.list[i]);
        }
      }

      if (toUpdate.length > 0) {
        let data = {
          list: JSON.stringify(toUpdate),
        };
        this.axiosCall("/remarks/set-openned-remarks", "POST", data).then(
          (res) => {
            if (res.data.status == 200) {
              console.log("CAlled");
            } else if (res.data.status == 400) {
              console.log("err");
            }
          },
        );
      }
    },

    handleSave() {
      this.isSubmitLoading = true;
      if (this.$refs.PendingRemarksFormref.validate()) {
        let data = {
          module_from: this.moduleFrom,
          id_to_remark: this.data.id,
          type_of: this.type,
          message: this.remarksMsg,
        };

        this.axiosCall("/remarks/set-pending-remarks", "POST", data).then(
          (res) => {
            if (res.data.status == 201) {
              this.isSubmitLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.$emit("saveRemarks", data);
              this.dialog = false;
              // this.closeD();
            } else if (res.data.status == 400) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          },
        );
      }
    },
  },
};
</script>
